// extracted by mini-css-extract-plugin
export default {"layout":"_2025b43eb0 _4e9c31d145 _6133b3b030","h_slide":"_4abdc130eb","category":"_68654ec7c7 b67142399d _6a76810537"};